"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _cuid = _interopRequireDefault(require("cuid"));

var Chat = function Chat(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({}, props, {
    uniqueId: uniqueId,
    iconName: "Chat"
  }), /*#__PURE__*/_react["default"].createElement("title", null, "chat"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.8 17.26c-1.347-1.31-2.182-3.139-2.182-5.163 0-0.062 0.001-0.124 0.002-0.186l-0 0.009v-5.26c-0.089-2.78-2.364-5.001-5.158-5.001-0.029 0-0.058 0-0.087 0.001l0.004-0h-7.3c-0.018-0-0.039-0-0.060-0-2.766 0-5.009 2.236-5.020 4.999v6.681c0.022 2.755 2.261 4.98 5.020 4.98 0.021 0 0.042-0 0.063-0l-0.003 0h14.3c0.335-0.009 0.603-0.283 0.603-0.62 0-0.172-0.070-0.328-0.183-0.44l-0-0zM11.98 16.42h-6.9c-0.012 0-0.026 0-0.041 0-1.713 0-3.106-1.372-3.139-3.077l-0-0.003v-6.68c0.034-1.708 1.426-3.080 3.139-3.080 0.014 0 0.029 0 0.043 0l-0.002-0h7.3c0.025-0.001 0.055-0.001 0.085-0.001 1.738 0 3.158 1.359 3.255 3.073l0 0.009v5.26c-0.001 0.038-0.001 0.084-0.001 0.129 0 1.606 0.4 3.118 1.106 4.442l-0.025-0.051zM11.66 6.9h-6.42c-0.467 0.070-0.822 0.469-0.822 0.95s0.354 0.88 0.817 0.949l0.005 0.001h6.42c0.467-0.070 0.822-0.469 0.822-0.95s-0.354-0.88-0.817-0.949l-0.005-0.001zM11.66 10.96h-6.42c-0.467 0.070-0.822 0.469-0.822 0.95s0.354 0.88 0.817 0.949l0.005 0.001h6.42c0.467-0.070 0.822-0.469 0.822-0.95s-0.354-0.88-0.817-0.949l-0.005-0.001z",
    fill: "url(#".concat(uniqueId, ")")
  }));
};

var _default = Chat;
exports["default"] = _default;